(() => {
  let t = (e) => {
    e &&
      e.querySelector(".image-with-text__video") &&
      new IntersectionObserver((e) => {
        e.forEach((e) => {
          e.isIntersecting ? e.target.play() : e.target.pause();
        });
      }).observe(e.querySelector(".image-with-text__video"));
  };
  t(document.currentScript.parentElement),
    document.addEventListener("shopify:section:load", function (e) {
      e.target.classList.contains("image-with-text-section") && t(e.target);
    });
})();
